module.exports = __webpack_public_path__ + "media/images/simple-7ae527855c8d92752dc36436bff39d75.svg";